import { TriggerModal } from './modalRoutes';
import { createRouter, createWebHistory } from 'vue-router';
import { removeEventListeners } from '@/classic/JqueryOverrides';
import { startTimer, stopTimer, resetTimers, setPageContext } from '@/services/admin_actions/pageTimerService';
import adminRoutes from '@/router/adminRoutes';
import federerationRoute from '@/router/federationRoute';
import { webRoutes, PerformWebRules, WebAfterRules} from '@/router/webRoutes';

declare let $: any;

const routes = [
  ...webRoutes, // Import app routes from the separate file
  ...adminRoutes, // Import admin routes from the separate file
  ...federerationRoute
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth' };
  },
});

router.beforeEach(async (to, from, next) => {
  resetTimers();
  setPageContext(to.fullPath);
  startTimer('router');
  
  await PerformWebRules(to, from, next);
  
  removeEventListeners();
  next();
});

router.afterEach(async (to, from) => {
  stopTimer('router');
  await WebAfterRules(to,from)
  TriggerModal();
  
  // Only dispatch fallback if not using FetchBodyContent
  if (!document.getElementById('external-content')) {
    setTimeout(() => {
      const event = new Event('body_content_loaded');
      document.dispatchEvent(event);
    }, 100);
  }
});

export default router;